let config = {
    // 版本
    version: '1.7.0',
    tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW',
    baseURL: '',
    wxBaseURL: ''
}
export default config;
